<template>
    <div>
        <ion-header>
            <ion-toolbar>
                <ion-title>{{ title }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button @click="closeModal()">
                        <ion-icon slot="icon-only" name="close"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
            <loading-bar
                v-if="$store.state.loadingCount > 0 && !$store.state.loading"
            ></loading-bar>
        </ion-header>
        <ion-content class="ion-padding">
            <slot></slot>
        </ion-content>
        <ion-footer no-border v-if="hasFooterSlot">
            <ion-toolbar>
                <slot name="footer"></slot>
            </ion-toolbar>
        </ion-footer>
    </div>
</template>

<script>
import LoadingBar from "./LoadingBar";

export default {
    name: "Modal",
    components: {
        LoadingBar,
    },
    props: {
        title: { type: String, default: "" },
        showDismissMessage: { type: Boolean, required: false, default: false },
        width: {
            type: String,
            required: false,
            default: "",
        },
        height: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return {};
    },
    mounted() {
        // console.log(this.$slots);
    },
    computed: {
        hasFooterSlot() {
            let result = false;
            if (
                this.$slots.hasOwnProperty("footer") &&
                this.$slots.footer.length > 0
            ) {
                result = true;
            }
            return result;
        },
    },
    methods: {
        closeModal() {
            if (this.showDismissMessage) {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message:
                            "Bereits vorgenommene Eingaben gehen verloren.",
                        buttons: [
                            {
                                text: "Abbrechen",
                                role: "cancel",
                            },
                            {
                                text: "Ok",
                                handler: () => {
                                    this.$ionic.modalController.dismiss();
                                },
                            },
                        ],
                    })
                    .then((a) => a.present());
            } else {
                this.$ionic.modalController.dismiss();
            }
        },
    },
};
</script>
